const machineData = [
    {
        name: 'The Machine',
        id: 'machine',
        sceneText: "The Machine",
        cluesAvailable: true,
        clues: [
            {
                text: "Press 'Initiate Shutdown' and fix the error codes displayed. Everything you need is on pages 9 & 10. If you request further hints the time limit will be increased."
            },
            {
                text: 'Your time limit has been increased by 15 seconds.'
            },
            {
                text: 'Your time limit has been increased by 30 seconds.'
            },
            {
                text: 'Your time limit has been increased by 60 seconds.'
            },
            {
                text: 'Your time limit has been increased by 120 seconds.'
            },
            {
                text: 'Your time limit has been doubled. If you request another hint the time limit will be removed.'
            },
            {
                text: 'The time limit has been removed.'
            }
        ]
    }
]

export default machineData